export interface EdocAddedBanner {
  companionCertificateLabel: string;
  edocBookingMessagesLabel: string;
}
